import './TaxonomyMapper.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {routes} from "../../routing/routes";
import {useStores} from "../../stores";
import {Button, Grid} from "@mui/material";
import {KoiFacade} from "../../components/koi-facade/KoiFacade";
import {generatePath, useLocation, useNavigate, useParams} from "react-router";
import Typography from "@mui/material/Typography";
import {TaxonomyMapperComponent} from "./mapper/TaxonomyMapperComponent";
import {ChevronRight, Refresh} from "@mui/icons-material";
import {TaxonomyMapperToolbar} from "./mapper/TaxonomyMapperToolbar";
import {generateHomePath} from "../../routing/routing.utils";
import {environment} from "../../env";
import type {Data} from "../../components/visualization/cmp-breakdown-single/CmpBreakdownSingleVisualization";
import {toCurrency} from "../../components/currency-component/CurrencyClasses";

export const TaxonomyMapperPage: React.FC = observer(() => {
    const {p, rootAppStore, taxonomyMapperStore, synergyStore} = useStores();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    // const theme = useTheme();
    // const mediaTablet = useMediaQuery(theme.breakpoints.down('md'));

    const dataCategoriesLeft: Data = {
        top: {
            id: "1",
            total: synergyStore.commonCategoriesDelegate.numberTotalCategoriesLeft,
            value: synergyStore.commonCategoriesDelegate.numberCommonCategoriesLeft,
            valueTitle: synergyStore.commonCategoriesDelegate.numberCommonCategoriesLeft.toString(),
            valueTitleHover: synergyStore.commonCategoriesDelegate.numberCommonCategoriesLeft.toString(),
        },
        bottom: {
            id: "2",
            total: synergyStore.commonCategoriesDelegate.totalCategoriesSpendLeft,
            value: synergyStore.commonCategoriesDelegate.commonCategoriesSpendLeft,
            valueTitle: toCurrency(p.currencySymbol, synergyStore.commonCategoriesDelegate.commonCategoriesSpendLeft, 3),
            valueTitleHover: toCurrency(p.currencySymbol, synergyStore.commonCategoriesDelegate.commonCategoriesSpendLeft, 3),
        },
    };

    const dataCategoriesRight: Data = {
        top: {
            id: "1",
            total: synergyStore.commonCategoriesDelegate.numberTotalCategoriesRight,
            value: synergyStore.commonCategoriesDelegate.numberCommonCategoriesRight,
            valueTitle: synergyStore.commonCategoriesDelegate.numberCommonCategoriesRight.toString(),
            valueTitleHover: synergyStore.commonCategoriesDelegate.numberCommonCategoriesRight.toString(),
        },
        bottom: {
            id: "2",
            total: synergyStore.commonCategoriesDelegate.totalCategoriesSpendRight,
            value: synergyStore.commonCategoriesDelegate.commonCategoriesSpendRight,
            valueTitle: toCurrency(p.currencySymbol, synergyStore.commonCategoriesDelegate.commonCategoriesSpendRight, 3),
            valueTitleHover: toCurrency(p.currencySymbol, synergyStore.commonCategoriesDelegate.commonCategoriesSpendRight, 3),
        },
    };

    const optionsLeft = {
        width: 1000,
        height: 500,
        margin: {top: 50, left: 0, bottom: 50, right: 0},
        alignRight: true,
        fixedWidth: false,
        barPortion: 0.5,
        flowStrokeWidth: 0,
        hoverVisible: false,
        defaultWideMargin: true,
    }

    const optionsRight = {
        width: 1000,
        height: 500,
        margin: {top: 50, left: 0, bottom: 50, right: 0},
        alignRight: false,
        fixedWidth: false,
        barPortion: 0.5,
        flowStrokeWidth: 0,
        hoverVisible: false,
        defaultWideMargin: true,
    }


    return (
        <KoiFacade
            title="Taxonomy Mapper"
            // helpContent={<PurchasePriceVarianceHelp/>}
            intro={<></>}
            back={generateHomePath(location, undefined, rootAppStore.app)}
            next={{
                type: 'component',
                node: <Button
                    color="primary"
                    variant="outlined"
                    endIcon={<ChevronRight/>}
                    onClick={() => {
                        if (environment.package === 'sales_demo') {
                            // After the taxonomy mapper is completed, go to the review page
                            navigate(generatePath(routes.demo_merge_taxonomy_mapper_review, params))
                        }
                        throw new Error('Not implemented');
                    }}>
                    Review
                </Button>
            }}
            className="taxonomy-mapper-page centered-header">

            <Grid container justifyContent="end" className="taxonomy-titles">
                <Grid
                    size={{
                        sm: 4
                    }}>{/* Or 7 to let the title span over the table as well*/}
                    <Typography variant="h3" className="taxonomy-title base-title">
                        {taxonomyMapperStore.baseTaxonomyName}
                    </Typography>
                </Grid>
                <Grid
                    className="text-center"
                    size={{
                        sm: 1
                    }}>
                    <Button
                        aria-label="refresh"
                        onClick={() => window.location.reload()}
                        disabled={taxonomyMapperStore.mapper.busy}>
                        <Refresh/>
                    </Button>
                </Grid>
                <Grid
                    size={{
                        sm: 4
                    }}>
                    <Typography variant="h3" className="taxonomy-title target-title">
                        {taxonomyMapperStore.targetTaxonomyName}
                    </Typography>
                </Grid>
            </Grid>

            <section className="taxonomy-mapper-main">
                <Grid container className="taxonomy-mapper-main-header">
                    <Grid
                        size={{
                            sm: 3
                        }}/>
                    <Grid
                        size={{
                            sm: 9
                        }}>
                        <TaxonomyMapperToolbar/>
                    </Grid>
                </Grid>
                <Grid container className="taxonomy-mapper-main-body">
                    <Grid
                        size={{
                            sm: 3
                        }}>
                        {/*<BaseTaxonomySupplierTable/>*/}
                    </Grid>
                    <Grid
                        id="taxonomy-mapper-viz-wrapper"
                        size={{
                            sm: 9
                        }}>
                        <TaxonomyMapperComponent/>
                    </Grid>
                </Grid>
            </section>
        </KoiFacade>
    );
});
